module.exports = __webpack_public_path__ + "img/STA.4dbb076e.jpg";